'use client';

import { getUnreadAnnouncementsAction, markAnnouncementsAsViewedAction } from '@/dal/feature-announcements/actions';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useAnnouncements = () => {
  const queryClient = useQueryClient();
  const { data, error, isLoading } = useQuery({
    queryKey: ['announcements'],
    queryFn: getUnreadAnnouncementsAction,
  });

  const markAsViewed = async () => {
    await markAnnouncementsAsViewedAction();
    queryClient.invalidateQueries({ queryKey: ['announcements'] }); // Revalidate the announcements list
  };

  return {
    announcements: data || [],
    isLoading,
    isError: error,
    markAsViewed,
  };
};
